export const getFilterTimeline = state => state.news.get('filterTimeline')
export const getShowFilterTimeline = state => {
  const loading = getFilterTimeline(state).get('loading')
  const data = getFilterTimeline(state).get('data')

  return Boolean(data && data.size > 0) || loading
}
